import { SingleOrArray } from "./types";

export function toArray<T>(input?: SingleOrArray<T>) {
  if (!input) return [];
  let items: T[] = [];
  if (Array.isArray(input)) items = input;
  else items.push(input);
  return items;
}
